import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getMaintenance,
  getIdMaintenance,
  createMaintenance,
  updateMaintenance,
  deleteMaintenance,
  updateMaintenanceSetStatus,
  updateMaintenanceConfirm,
  updateMaintenanceCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteMaintenanceVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  getTransportations,
  createTransportations,
  updateTransportations,
  deleteTransportations,
  updateMaintenanceStartWorkFlow,
  uploadMaintenance,
  updateMaintenanceAmend,
  uploadPicking,
  uploadBTS,
  uploadInspect,
  uploadMaintenanceWorkflow,
  updateMaintenanceAmmend,
  uploadRePdi,
  uploadRePdiout,
  getGenerateExcelBlob
} from "./maintenanceAPI";

const initialState = {
  data: [],
  dataParty: [],
  dataPartyAll: [],
  dataTransportations: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  pageNoParty: 1,
  pageSizeParty: 10,
  totalRecordParty: 0,

  pageNoTransportations: 1,
  pageSizeTransportations: 10,
  totalRecordTransportations: 0,

  permissionsMaintenance: [],
  permissionsInspect: [],
  permissionsRepdiin: [],
  permissionsRepdiout: [],
  permissionsList: [],
};

export const fetchMaintenance = createAsyncThunk(
  "Maintenance/fetchMaintenance",
  async (payload) => {
    const response = await getMaintenance(payload);
    return response;
  }
);

export const addMaintenance = createAsyncThunk(
  "Maintenance/addMaintenance",
  async (payload) => {
    const response = await createMaintenance(payload);
    return response;
  }
);

export const editMaintenance = createAsyncThunk(
  "Maintenance/editMaintenance",
  async (payload) => {
    const response = await updateMaintenance(payload);
    return response;
  }
);

export const editMaintenanceConfirm = createAsyncThunk(
  "Maintenance/editMaintenanceConfirm",
  async (payload) => {
    const response = await updateMaintenanceConfirm(payload);
    return response;
  }
);
export const editMaintenanceAmmend = createAsyncThunk(
  "Maintenance/editMaintenanceAmmend",
  async (payload) => {
    const response = await updateMaintenanceAmmend(payload);
    return response;
  }
);

export const editMaintenanceCancel = createAsyncThunk(
  "Maintenance/editMaintenanceCancel",
  async (payload) => {
    const response = await updateMaintenanceCancel(payload);
    return response;
  }
);

export const editMaintenanceStarWorkflow = createAsyncThunk(
  "Maintenance/editMaintenanceStarWorkflow",
  async (payload) => {
    const response = await updateMaintenanceStartWorkFlow(payload);
    return response;
  }
);

export const fetchIdMaintenance = createAsyncThunk(
  "Maintenance/fetchIdMaintenance",
  async (id) => {
    const response = await getIdMaintenance(id);
    return response;
  }
);

export const removeMaintenance = createAsyncThunk(
  "Maintenance/removeMaintenance",
  async (payload) => {
    const response = await deleteMaintenance(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "Maintenance/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadMaintenance(id, file);
    return response;
  }
);

export const AddUploadFileMaintenance = createAsyncThunk(
  "Maintenance/AddUploadFileMaintenance",
  async ({ id, file }) => {
    const response = await uploadMaintenanceWorkflow(id, file);
    return response;
  }
);
export const AddUploadFileInspect = createAsyncThunk(
  "Maintenance/AddUploadFileInspect",
  async ({ id, file }) => {
    const response = await uploadInspect(id, file);
    return response;
  }
);
export const AddUploadFileRepdi = createAsyncThunk(
  "Maintenance/AddUploadFileRepdi",
  async ({ id, file }) => {
    const response = await uploadRePdi(id, file);
    return response;
  }
);
export const AddUploadFileRepdiout = createAsyncThunk(
  "Maintenance/AddUploadFileRepdiout",
  async ({ id, file }) => {
    const response = await uploadRePdiout(id, file);
    return response;
  }
);

// vihicle
export const fetchMaintenanceVehicle = createAsyncThunk(
  "Maintenance/fetchMaintenanceVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addMaintenanceVehicle = createAsyncThunk(
  "Maintenance/addMaintenanceVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);
export const removeMaintenanceVehicle = createAsyncThunk(
  "Maintenance/removeMaintenanceVehicle",
  async (payload) => {
    const response = await deleteMaintenanceVehicles(payload);
    return response;
  }
);

export const editMaintenanceVehicle = createAsyncThunk(
  "Maintenance/editMaintenanceVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

// party
export const fetchMaintenanceParty = createAsyncThunk(
  "Maintenance/fetchMaintenanceParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchMaintenancePartyAll = createAsyncThunk(
  "Maintenance/fetchMaintenancePartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addMaintenanceParty = createAsyncThunk(
  "Maintenance/addMaintenanceParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editMaintenanceParty = createAsyncThunk(
  "Maintenance/editMaintenanceParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeMaintenanceParty = createAsyncThunk(
  "Maintenance/removeMaintenanceParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "Maintenance/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

export const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermisionMaintenance: (state, action) => {
      state.permissionsMaintenance = action.payload;
    },
    setPermisionInspect: (state, action) => {
      state.permissionsInspect = action.payload;
    },
    setPermisionRepdiin: (state, action) => {
      state.permissionsRepdiin = action.payload;
    },
    setPermisionRepdiout: (state, action) => {
      state.permissionsRepdiout = action.payload;
    },

    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMaintenanceConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenanceConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMaintenanceAmmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenanceAmmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMaintenanceCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenanceCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMaintenanceStarWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenanceStarWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileInspect.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileInspect.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileRepdi.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileRepdi.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileRepdiout.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileRepdiout.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchMaintenanceVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaintenanceVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addMaintenanceVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMaintenanceVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMaintenanceVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMaintenanceVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMaintenanceVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMaintenanceVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermisionInspect,
  setPermisionList,
  setPermisionMaintenance,
  setPermisionRepdiin,
  setPermisionRepdiout,
} = maintenanceSlice.actions;

export const selectMaintenance = (state) => state.maintenance.data;
export const selectMaintenanceVehicle = (state) => state.maintenance.data;
export const selectIdMaintenance = (state) => state.maintenance.dataId;
export const selectLoading = (state) => state.maintenance.loading;
export const selectError = (state) => state.maintenance.error;
export const selectPageNo = (state) => state.maintenance.pageNo;
export const selectPageSize = (state) => state.maintenance.pageSize;
export const selectTotalRecord = (state) => state.maintenance.totalRecord;
export const selectSelected = (state) => state.maintenance.selected;
export const selectResult = (state) => state.maintenance.result;

export const selectPermissionMaintenance = (state) =>
  state.maintenance.permissionsMaintenance;

export const selectPermissionInspect = (state) =>
  state.maintenance.permissionsInspect;

export const selectPermissionRepdiin = (state) =>
  state.maintenance.permissionsRepdiin;

export const selectPermissionRepdiout = (state) =>
  state.maintenance.permissionsRepdiout;

export const selectPermissionList = (state) =>
  state.maintenance.permissionsList;

export default maintenanceSlice.reducer;
